import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Phone, ShieldCheck } from 'lucide-react';

export const HeroSection = () => (
  <section className="relative min-h-[88vh] flex items-end overflow-hidden pt-20 bg-primary-blue" data-testid="hero-section">
    {/* Vidéo de fond */}
    <video
      className="absolute inset-0 w-full h-full object-cover"
      src="/hero-video.mp4"
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      aria-hidden="true"
    />
    {/* Voile dégradé : transparent en haut (vidéo bien visible), foncé en bas pour la lisibilité du texte */}
    <div className="absolute inset-0 bg-gradient-to-t from-primary-blue/95 via-primary-blue/55 to-primary-blue/5" />

    {/* Contenu (aligné en bas) */}
    <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8 pb-8 md:pb-12">
      <div className="max-w-3xl fade-in-up">
        <p className="text-sm uppercase tracking-[0.3em] font-semibold text-accent-blue mb-8">
          Cabinet d’expertise comptable · Lyon
        </p>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <Button asChild className="bg-white hover:bg-accent-blue text-primary-blue hover:text-white rounded-full px-8 py-6 text-base font-medium">
            <Link to="/contact" data-testid="hero-cta-rendez-vous" className="flex items-center gap-2">
              <Phone className="w-5 h-5" />
              Prendre rendez-vous
            </Link>
          </Button>
          <Link
            to="/services"
            data-testid="hero-cta-services"
            className="group inline-flex items-center gap-2 text-base font-medium text-white underline underline-offset-8 decoration-2 decoration-accent-blue"
          >
            Découvrir nos services
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
        <div className="flex items-center gap-3 mt-12 text-white/70">
          <ShieldCheck className="w-5 h-5 text-accent-blue flex-shrink-0" />
          <span className="text-sm">Expert-comptable diplômé DEC · Inscrit à l’Ordre des Experts-Comptables</span>
        </div>
      </div>
    </div>
  </section>
);
